<template lang="html">
  <div class="animation-main" v-show="el.startTransfer!==''&&!showLeft.left">
    <transition name="fade">
      <i v-if="show" class="material-icons">insert_drive_file</i>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      el: 'el',
      app: 'app',
      showLeft: 'show'
    })
  },
  watch: {
    'el.startTransfer': function () {
      if (this.el.startTransfer !== '' && this.app.login) {
        clearTimeout(this.timeoutFunc)
        this.timeoutFunc = setTimeout(() => {
          this.$store.dispatch('transferEl', '')
          this.show = true
        }, 1100)
        setTimeout(() => {
          this.show = false
        }, 10)
      } else {
        this.show = true
      }
    }
  },
  data () {
    return {
      timeoutFunc: null,
      show: true
    }
  },
  methods: {
  }
}
</script>

<style lang="css" scoped>
.animation-main {
  position: absolute;
  background: transparent;
  z-index: 4;
  width: 220px;
  height: 150px;
  top: 60px;
  left: 20px;
}
.animation-main i {
  zoom: 1;
  font-size: 60px;
  color: #3a9bd9;
  position: absolute;
  left: 150px;
  top: 80px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 4s;
  transition: transform 1s;
}
.fade-leave-to {
  /* opacity: 0.2; */
  transform: scale(.4);
  animation: left-in 1s ease-in,top-in 1s ease;
  transform-origin: 0% 0%;
  /* transform: translateX(10px); */
}
/* .fade-leave-to {
  top:0px;
} */
@keyframes left-in {
  from {
    left: 170px;
  }
  to {
    left: 0px;
  }
}
@keyframes top-in {
  from {
    top: 60px;
  }
  to {
    top: 8px;
  }
}
</style>
